/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Admin_Impersonate_UserInputs */

const en_mobile_admin_impersonate_user = /** @type {(inputs: Mobile_Admin_Impersonate_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impersonate user`)
};

const es_mobile_admin_impersonate_user = /** @type {(inputs: Mobile_Admin_Impersonate_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impersonar usuario`)
};

/**
* | output |
* | --- |
* | "Impersonate user" |
*
* @param {Mobile_Admin_Impersonate_UserInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_admin_impersonate_user = /** @type {((inputs?: Mobile_Admin_Impersonate_UserInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Admin_Impersonate_UserInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_admin_impersonate_user(inputs)
	return en_mobile_admin_impersonate_user(inputs)
});